<template lang="pug">
  .notification-status-change
    router-link(:to="{name: routeName, params: { boardSlug: notification.meta.feature.board.slug, featureSlug: notification.meta.feature.slug } }")
      .row.center
        .col.notification-avatar
          UserAvatar(:user="notification.meta.user", :icon="['fas', 'arrow-right']")
        .col.max
          p {{ notification.description }}
</template>

<script>

export default {
  name: 'NotificationStatusChange',
  props: {
    notification: Object
  },
  mounted () {
  },
  computed: {
    routeName () {
      return this.$route.meta.member || (this.$route.name.indexOf('Admin') > -1) ? 'AdminFeature' : 'PublicFeature'
    }

  }
}
</script>

<style scoped lang="stylus">
</style>
